var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.566 8.65742C17.852 8.3558 18 7.95016 18 7.55493C18 7.1597 17.8619 6.76447 17.5758 6.45244C16.9938 5.84919 16.0567 5.84919 15.4846 6.45244L12 10.1162C11.9951 10.1161 11.9902 10.1161 11.9852 10.1162L8.52034 6.45244C7.93835 5.84919 7.00123 5.84919 6.4291 6.45244C5.85697 7.06609 5.85697 8.05417 6.4291 8.65742L9.59827 11.999L6.43403 15.3426C6.14796 15.6442 6 16.0498 6 16.4451C6 16.8403 6.1381 17.2355 6.42417 17.5476C7.00616 18.1508 7.94328 18.1508 8.51541 17.5476L12 13.8838C12.0049 13.8839 12.0098 13.8839 12.0148 13.8838L15.4797 17.5476C16.0617 18.1508 16.9988 18.1508 17.5709 17.5476C18.143 16.9339 18.143 15.9458 17.5709 15.3426L14.4017 12.001L17.566 8.65742Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.4140a5c0.svg";
export { ForwardRef as ReactComponent };